module.exports = __webpack_public_path__ + "static/media/6.46f167f4.jpg";